// @noflow
import { FormattedMessage } from 'react-intl';
import messages from './intl';
import { momentDurationObj } from 'react-moment-proptypes';
import * as React from 'react';

const TimeSpan = ({ value }) => (
    <div data-qa="timespan">
        <FormattedMessage
            {...messages.timespan}
            values={{
                years: value.years(),
                months: value.months(),
                days: value.days(),
                hours: value.hours(),
                minutes: value.minutes(),
                seconds: value.seconds()
            }}
        />
    </div>
);

TimeSpan.propTypes = {
    value: momentDurationObj
};

export default TimeSpan;



// WEBPACK FOOTER //
// ./src/components/widgets/timespan/index.js